const registration = {
  registration: {
    backButton: 'サインインに戻る',
    pageHeader: '新規ユーザー登録',
    installerNote: 'ユーザーIDを作成し、招待を受けるには、貴社/支店の管理者に連絡してください',
    registerOption: 'Enphaseに新しいソーラー会社を登録したい',
    installerOption: '私は、すでにEnphaseシステムを設置している会社で働いている設置業者です',
    doItYourselfOption: '私はEnphase製品を自分で設置するユーザーです',
    homeownerOption: '私は住宅所有者です',
    updateSignuppage: '私は、私のシステムに関連するシステム情報、アップグレード、またはマーケティングメッセージについて、上記に入力した電話番号に電話およびテキストメッセージでEnphaseから連絡がくることに同意します。このようなマーケティング目的の電話やメールは、自動ダイヤルであったり、人工音声または事前に録音された音声によって生成される場合があります。これらの通信に対する私の同意は、いかなる購入の条件でもなく、いつでも、いかなる合理的な手段によっても取り消すことができます。',
    termsAndServices: '私は、Enphaseの %{privacyPolicy} を読み、%{termsService} に同意します。',
    termsServicesSafetyDisclaimer:
      '私は、Enphaseの %{safetyDisclaimer}、%{privacyPolicy} および %{termsService} を読み、同意したことを認めます。',
    safetyDisclaimer: '安全に関する免責事項',
    accountHeader: 'アカウント詳細',
    companyDetails: '会社詳細',
    firstName: '名',
    lastName: '姓',
    country: '国',
    email: 'メール',
    verificationHeader: '認証コードを入力',
    verificationNote: '%{email} に送信された6桁の認証コードを入力してください',
    didntReceivedOtp: '認証コードが届きませんか？',
    resendOtp: '認証コードを再送する',
    setPasswordHeader: 'Enlightenパスワードを設定する',
    setPasswordNote:
      '文字数は 6 文字以上 50 文字以下で、数字または特殊文字を1文字以上含む必要があります。',
    password: 'パスワード',
    confirmPassword: 'パスワードの確認',
    safetyDisclaimerNote:
      'Enphase製品の設置、サービスおよびメンテナンスは、有資格者のみが行ってください。電気工事は、地域または領域に適用される電気工事規約の訓練を受け、太陽光発電、蓄電、エネルギー管理システムに関連する法的要件と安全上の考慮事項についての知識を有する、免許を有する電気工事士によって行われなければなりません。必ず設置マニュアルやガイドを参照してください。',
    fieldRequired: 'このフィールドは必須です。',
    validEmail: '有効なメールアドレスを入力してください。',
    validPhone: '有効な電話番号を入力してください。',
    validChamberNumber: '無効な入力です!商工会議所番号には最低 8 文字が必要です',
    companyName: '会社名',
    streetAddress: '住所',
    streetAddress2: '住所2',
    city: '市区町村',
    state: '都道府県',
    zip: '郵便番号',
    chamberofcommerce: '商工会議所番号',
    supportEmail: 'カスタマーサポートメール',
    supportPhone: 'カスタマーサポート',
    wesbiteUrl: 'ウェブサイトの URL',
    companyLogo: '会社ロゴ',
    chooseFile: 'ファイルを選択',
    noFile: 'ファイルが選択されていません',
    chooseFileNote:
      '4MB 以下の JPEG、GIF または PNG ファイルであること。最良の結果を得るためには、少なくとも幅 400px、高さ 400px の、透明な背景を持つ正方形の画像をお勧めします。',
    enphaseInstaller: 'この会社は、Enphaseシステムを設置している、または設置を計画しています',
    privacyPolicy: 'プライバシーポリシー',
    termsService: '利用規約',
    andText: 'および',
    accountNote: '備考：このアカウントで追加されたシステムは、メンテナンスのために設置業者にタグ付けされることはありません',
    phone: '電話',
    passwordMismatch: '上記のフィールドに入力されたパスワードは、互いに一致する必要があります',
    updateSignupError: '上記のチェックボックスを選択して登録を進めてください',
    privaryPolicyError:
      'Enphase のプライバシーポリシーおよび利用規約に同意されない場合は、Enlighten に登録することはできません。',
    otpSuccess: '認証コードが正常に再送信されました',
    registrationSuccess: 'Enlightenアカウントは正常に作成されました',
    registrationSuccessRedirection: 'Enlightenへの登録が完了しました。サインインしています...',
    login: 'ログイン',
    warningName:
      '警告：この名前の会社はすでにシステムに存在しています。正しいアクセスを確実にするために、会社/支店の管理者に連絡してユーザーIDを作成するか、Enphase Supportにご連絡ください。',
    errorName:
      'この名前の会社はすでにシステムに存在しています。正しいアクセスを確実にするために、会社/支店の管理者に連絡してユーザーIDを作成するか、Enphase Supportにご連絡ください。',
    warningAddress:
      '警告：この住所は、システムにすでに存在する会社に関連付けられています。正しいアクセスを確実にするために、会社/支店の管理者に連絡してユーザーIDを作成するか、Enphase Supportにご連絡ください。',
    errorSupportEmail:
      'このメールIDは、システムにすでに存在する会社に関連付けられています。正しいアクセスを確実にするために、会社/支店の管理者に連絡してユーザーIDを作成するか、Enphase Supportにご連絡ください。',
    errorSupportPhone:
      'この電話番号は、システムにすでに存在する会社に関連付けられています。正しいアクセスを確実にするために、会社/支店の管理者に連絡してユーザーIDを作成するか、Enphase Supportにご連絡ください。',
    warningUrl:
      'このウェブサイトのリンクは、システムにすでに存在する会社に関連付けられています。正しいアクセスを確実にするために、会社/支店の管理者に連絡してユーザーIDを作成するか、Enphase Supportにご連絡ください。',
    errorPhone:
      'この電話番号はすでに既存のアカウントに関連付けられています。別の連絡先番号を使用するか、Enphase Supportまでご連絡ください。',
    errorEmail:
      'このメールアドレスは、すでに既存のアカウントに関連付けられています。別のメールアドレスを使用するか、Enphase Supportまでお問い合わせください。',
    streetNumberEmptyError: '住所が見つかりません。保存する前に確認してください。',
    recaptchaError: '次に進むにはreCAPTCHA認証を完了してください。',
    infoText: 'マーカーが正確な位置に設置されていることを確認してください。',
    warningText: '必ず正確な位置にマーカーを置いてください。',
    locateMeText: '現在地を知るには、「現在地を取得」ボタンを使用します。',
    addressCheckText: '正しい住所を入力してください',
    markerText: 'マーカーを正確な位置に置いてください',
    mapErrorText: '申し訳ありません!グーグルマップでは場所が特定できませんでした。'
  }
};

export default registration;
